import { createAction } from 'redux-starter-kit';
import { notification } from 'antd';
import { post } from '../../../utility/via-fetch';
import { putUser } from '../../domain/users/userActions';
import { requestStart, requestSucceded, requestFailed } from '../../domain/requests/RequestActions';
import { setSessionUser } from '../application/sessionUiActions';
import { addMessage } from '../application/messageUiActions';


/**
 * An action to keep track of the current login email address for accessing between unauth pages
 */
export const setCurrentLoginAddress = createAction('SET_CURRENT_LOGIN_ADDRESS');

/**
 * An action that signifies a request to fetch a user has been made.
 * @param {string} requestId The id of the request.
 * @example dispatch(fetchAuthenticateUser(requestId))
 */
export const fetchAuthenticateUser = createAction('FETCH_AUTHORISE_USER');

/*
 * An action that signifies a request to accept the legal documents for full access to the platform.
 * @param {string} requestId The id of the request.
 * @example dispatch(attemptAcceptTermsAndConditions(requestId))
 */
export const acceptTermsAndConditions = createAction('ACCEPT_TERMS_AND_CONDITIONS');

/**
 * An action that makes an authorising request to the server.
 * @param {string} username The username representing a user.
 * @param {string} password The password that will authorise access to the user.
 * @example dispatch(requestAuthenticateUser(username, password));
 */
export function requestAuthenticateUser(username, password) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchAuthenticateUser.toString()));
    dispatch(fetchAuthenticateUser(requestId));

    try {
      const { user } = await post('/api/security/sign-in', undefined, { username, password, appVersion: "WEB" });
      dispatch(putUser(user)); // Update the users domain with our new user.
      dispatch(setSessionUser(user.userId)); // Update the session state with the user identifier.
      dispatch(requestSucceded(requestId)); // Update request with the payload.
      notification.destroy();
      dispatch(addMessage('success', 'sessionStarted'));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
      dispatch(addMessage('error', 'loginFailed'));
    }
  };
}

/*
 * An action that saves the accepted terms and conditions to the server
 */
export function requestAcceptTermsAndConditions(termsOfUseToAccept, privacyPolicyToAccept, eulaToAccept, onFail) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(acceptTermsAndConditions.toString()));
    dispatch(acceptTermsAndConditions(requestId));

    try {
      const user = await post('/api/users/accept-legal-documents', undefined, { termsOfUseToAccept, privacyPolicyToAccept, eulaToAccept });
      dispatch(putUser(user)); // override the user with our new 'accepted' user
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId)); // We failed.
      dispatch(addMessage('error', 'termsUpdated'));
      onFail();
    }
  };
}
